import React, { ReactElement, useEffect } from "react";
import { ActionIcon, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { JsxElement } from "typescript";

export type ListItemActionProps = {
  id: string;
  verify: {
    show: boolean | undefined;
    message?: string;
    button?: string;
    callback?: () => void;
  };
  callback: () => void;
  element: ReactElement<JsxElement>;
  active: boolean;
};
export type ListItemActionsProps = {
  elements: ListItemActionProps[];
};
const ListItemActions: React.FC<ListItemActionsProps> = ({ elements }) => {
  const [verify, setVerify] = React.useState<ListItemActionProps>();

  useEffect(() => {
    if (verify && verify.verify.show && verify.verify.callback) {
      verify.verify.callback();
    }
  }, [verify]);

  return (
    <>
      <Group spacing="sm">
        {elements.map((cta) => (
          <ActionIcon
            id={cta.id}
            size={18}
            disabled={!cta.active}
            key={cta.id}
            className="action-icon"
            onClick={() => setVerify(cta)}
          >
            {cta.element}
          </ActionIcon>
        ))}
      </Group>
      <Modal
        opened={(verify && verify.verify.show) === true}
        onClose={() => setVerify(undefined)}
        title="Confirm"
      >
        <Stack>
          <Text align="center">{verify?.verify?.message}</Text>
          {verify && (
            <Button
              variant="filled"
              onClick={() => {
                setVerify(undefined);
                verify.callback();
              }}
            >
              {verify?.verify?.button}
            </Button>
          )}
        </Stack>
      </Modal>
    </>
  );
};
export default ListItemActions;
